<div theme border class="bg-white rounded-2xl relative overflow-hidden group"
  [class.p-4]="item.socialName==='promotion'" [class.h-full]="item.socialName==='promotion'" (click)="selectItem()"
  [class.border-[4px]]="isSelected">

  <div *ngIf="isOperating"
    class="absolute top-0 left-0 z-10 w-full h-full flex justify-center items-center bg-[#ffffff6b]">
    <ig-spinner></ig-spinner>
  </div>

  <div class="shadow-md transition-all cursor-pointer rounded-2xl relative hover:shadow-xl">

    <div class="absolute left-0 top-0 rounded-tl-xl flex opacity-90">
      <div class="">
        <div class="bg-[#9bd53e] text-black text-[10px] w-[100px] text-center py-[3px] rounded-tl-xl"
          [class.bg-[pink]]="!item?.isApproved">
          {{ item?.isApproved ? 'Approved' : 'Pending approval' }}</div>
        <div *ngIf="item?.isChoice" class="bg-gray-600 text-white text-[10px] w-[100px] text-center py-[3px]">
          {{ getItemType() === 'event' ? editorChoiceText.editorChoiceForEvent : editorChoiceText.editorChoiceForPlace
          }}
        </div>
        <div class="bg-orange-300 text-black text-[10px] w-[100px] text-center py-[3px]">
          {{ getDisplaySocialName() }}
        </div>
        <div *ngIf="item?.isToBeExport" class="bg-blue-400 text-black text-[10px] w-[100px] text-center py-[3px]">
          PDF Export
        </div>
        <div *ngIf="shouldShowEnlargeImage" class="bg-[#06bb06] text-black text-[10px] w-[100px] text-center py-[3px]"
          (click)="enlargeImage($event)"
          matTooltip="The clarity of this image seems insufficient. Click here to try upscaling it"
          igClickStopPropagation>
          <mat-icon class="!h-[9px] !w-4">autorenew</mat-icon>Upscale image
        </div>
      </div>
      <div class="">
        <div *ngIf="isInAnyItinerary" class="bg-blue-400 text-black text-[10px] w-[100px] text-center py-[3px]">
          In itineraries
        </div>
        <div *ngIf="item['isLocked']" class="bg-blue-500 text-black text-[10px] w-[100px] text-center py-[3px]">
          Locked
        </div>
        <div *ngIf="isInCustomCategory()" class="bg-blue-600 text-black text-[10px] w-[100px] text-center py-[3px]">
          In Custom Btn
        </div>
        <div *ngIf="item['business_status']?.includes('CLOSED')" class="bg-red-500 text-white text-[10px] w-[100px] text-center py-[3px]">
          Closed
        </div>
      </div>
    </div>

    <ig-image [src]="item?.cover?.source" [alt]="item?.name"
      cls="w-full object-cover aspect-[5/3] rounded-t-xl"></ig-image>

    <div class="p-4 bg-white h-[18rem] relative rounded-b-xl">
      <div *ngIf="item.pinnedTime" theme bg
        class="rounded-[4px] px-2 py-0.5 text-white text-[11px] mb-1 w-fit -translate-y-1">Pinned Top
      </div>

      @if (getItemType() === 'event') {
      <div class="text-sm text-gray-600"><span>&#64;</span>{{ item?.owner?.name }}</div>
      <div class="text-sm text-gray-600 font-bold mt-2 mb-3">{{ item?.title || item?.name }}</div>
      <div *ngIf="item?.description" class="text-xs text-gray-600 mb-3 max-lines-3">{{
        processDescription(item?.description) }}</div>
      <div class="text-sm text-gray-600 mb-3">
        <ng-container *ngIf="item.eventTimes&&item.eventTimes.length<=1">
          <span class="text-center relative" *ngIf="item.timeOneLine"
            [class.one-line-time-long]="item.timeOneLine.length>37">{{item.timeOneLine}}</span>
        </ng-container>
        <!-- <div *ngIf="item.eventTimes&&item.eventTimes.length>1" class="flex flex-col">
          <span *ngFor="let time of item.eventTimes" class="relative text-xs"
            [class.one-line-time-long]="time.timeOneLine.length>37">{{time.timeOneLine}}</span>
        </div> -->
        <div *ngIf="item.eventTimes&&item.eventTimes.length>1" class="flex flex-col">
          <span *ngFor="let time of item.eventTimes | slice:0:3" class="relative text-xs"
            [class.one-line-time-long]="time.timeOneLine.length>37">{{time.timeOneLine}}</span>
          <div *ngIf="item.eventTimes.length > 3" class="text-blue-500 cursor-pointer" igClickStopPropagation
            #moreTimeTrigger="matMenuTrigger" [matMenuTriggerFor]="moreTimeMenu">
            Show more
          </div>
          <mat-menu #moreTimeMenu="matMenu" class="p-4 text-xs text-gray-600 !max-w-[343px] w-[343px] max-h-[50vh]">
            <div *ngFor="let time of item.eventTimes" class="flex flex-col">
              <mat-menu-item class="text-sm">{{time.timeOneLine}}</mat-menu-item>
            </div>
          </mat-menu>
        </div>
      </div>

      <!-- <ig-event-time *ngIf="getItemType()==='event'" [item]="item"></ig-event-time> -->

      <div class="text-sm text-gray-600">
        <span *ngIf="item['venue']">{{ item.venue }}, </span>
        <span *ngIf="getItemType()==='event'">
          {{ item.address?.address || (item.isOnlineEvent ? 'Online Event' : '(no location)') }}</span>

      </div>
      } @else {

      <div class="text-sm text-gray-600">
        <div *ngIf="!isSearchName" class="font-bold mb-3 text-green">{{ item?.name }}</div>
        <div *ngIf="isSearchName" class="font-bold mb-3 text-red" [innerHTML]="item?.name | highlight:keyword"></div>
        <div class="flex items-start">
          <mat-icon class="leading-5 min-w-6">room</mat-icon>
          <span *ngIf="isSearchAddress" [innerHTML]="(item.address || '(no location)')| highlight:keyword"></span>
          <span *ngIf="!isSearchAddress">{{ item.address || '(no location)' }}</span>
        </div>

        <div class="flex items-start">
          <mat-icon class="leading-5 min-w-6">list</mat-icon>
          <span *ngIf="isSearchCategory" [innerHTML]="getDisplayCategory(item)| highlight:keyword"></span>
          <span *ngIf="!isSearchCategory">{{ getDisplayCategory(item) }}</span>
        </div>

        <div *ngIf="item.rating" class="flex items-start">
          <mat-icon class="leading-5 min-w-6">star</mat-icon>
          Rating: {{ item.rating }} / User Ratings Total: {{ item.user_ratings_total}}
        </div>

        <div *ngIf="item.priceRange" class="flex items-start">
          <mat-icon class="leading-5 min-w-6">paid</mat-icon>
          <span *ngIf="item.priceRange === '1'">$</span>
          <span *ngIf="item.priceRange === '2'">$$</span>
          <span *ngIf="item.priceRange === '3'">$$$</span>
          <span *ngIf="item.priceRange === '4'">$$$$</span>
        </div>

        <div *ngIf="item?.description" class="mt-3 max-lines-3">{{
          processDescription(item?.description) }}
        </div>

      </div>

      }

    </div>
  </div>

  <!-- <div class="absolute right-0 w-full flex item-center cursor-pointer opacity-100 bottom-0 transition-all" igClickStopPropagation> -->
  <!-- <div class="absolute -bottom-3 right-0 w-full flex item-center cursor-pointer group-hover:opacity-100 group-hover:bottom-0 opacity-0 transition-all" igClickStopPropagation> -->
  <div class="absolute -bottom-7 right-0 w-full flex item-center cursor-pointer transition-all noHover:bottom-0 "
    [class.group-hover:opacity-100]="!menuIsOpen" [class.group-hover:bottom-0]="!menuIsOpen"
    [class.!opacity-100]="menuIsOpen" [class.!bottom-0]="menuIsOpen" igClickStopPropagation>
    <button theme class="rounded-bl-xl text-white w-[70%]" (click)="onEdit()">EDIT</button>
    <a *ngIf="item.eventLink" href="{{item.eventLink}}" target="_blank" class="!w-[15%] text-center bg-gray-100 border-r border-gray-300 ">
      <mat-icon matTooltip="View Source"
      matTooltipPosition="above"
      class="text-[20px] leading-6 text-gray-600 !leading-7">open_in_new</mat-icon>
    </a>
    <mat-icon *ngIf="!item.isApproved" (click)="approve()" matTooltip="Approve this {{ getItemType() }}"
      matTooltipPosition="above"
      class="text-green-500 bg-gray-100 border-r border-gray-300 text-[20px] !leading-7 !h-7 !w-[15%] text-center">check</mat-icon>
    <mat-icon *ngIf="item.isApproved" (click)="unapprove()" matTooltip="Reject this {{ getItemType() }}"
      matTooltipPosition="above"
      class="text-red-500 bg-gray-100 border-r border-gray-300 text-[20px] !leading-7 !h-7 !w-[15%] text-center">close</mat-icon>
    <mat-icon [matMenuTriggerFor]="moreMenu" (menuOpened)="onMenuOpened()" (menuClosed)="onMenuClosed()"
      class="text-gray-600 bg-gray-100 rounded-br-xl text-[20px] !leading-7 !h-7 !w-[15%] text-center">more_horiz</mat-icon>

    <mat-menu #moreMenu="matMenu" xPosition="before" yPosition="above" class="min-w-[200px]">
      <button mat-menu-item [matMenuTriggerFor]="itineraryMenu">Itineraries</button>
      <button mat-menu-item [matMenuTriggerFor]="categoryMenu">Custom Categories</button>
    </mat-menu>

    <mat-menu #itineraryMenu="matMenu" class="min-w-[200px] max-h-[40vh]">
      @for (itinerary of itineraries; track $index) {
      <button *ngIf="!isInSpecificItinerary(itinerary._id)" (click)="addToItinerary(itinerary._id)" mat-menu-item>
        <mat-icon class="leading-5 min-w-6 !text-green-500">add</mat-icon>
        Add to {{itinerary.title}}
      </button>
      <button *ngIf="isInSpecificItinerary(itinerary._id)" (click)="removeFromItinerary(itinerary._id)" mat-menu-item>
        <mat-icon class="leading-5 min-w-6 !text-red-500">remove</mat-icon>
        Remove from {{itinerary.title}}
      </button>
      }
    </mat-menu>

    <mat-menu #categoryMenu="matMenu" class="min-w-[200px]">
      @if (getItemType() === 'event') {
      @for(type of _customEvents; track $index) {
      <button *ngIf="!isInSpecificCategory($index); else elseBlock" mat-menu-item
        (click)="addToCategory($index)">{{type.btnText}}<mat-icon
          class="leading-6 min-w-6 !text-green-500">add</mat-icon></button>
      <ng-template #elseBlock>
        <button mat-menu-item (click)="removeFromCategory($index)">{{type.btnText}}<mat-icon
            class="leading-6 min-w-6 !text-red-500">remove</mat-icon></button>
      </ng-template>
      }
      } @else {
      @for(type of _customPlaces; track $index) {
        <button *ngIf="!isInSpecificCategory($index); else elseBlock" mat-menu-item
        (click)="addToCategory($index)">{{type.btnText}}<mat-icon
          class="leading-6 min-w-6 !text-green-500">add</mat-icon></button>
      <ng-template #elseBlock>
        <button mat-menu-item (click)="removeFromCategory($index)">{{type.btnText}}<mat-icon
            class="leading-6 min-w-6 !text-red-500">remove</mat-icon></button>
      </ng-template>
      }
      }
    </mat-menu>
  </div>
</div>
